import { Link } from "react-router-dom";
import { siteConfig, categories } from "@/mocks/siteData";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-bold text-foreground-950 font-heading mb-4">
              {siteConfig.name}
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {siteConfig.description}
            </p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  帮助中心
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  版权声明
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关注我们</h4>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer"
                aria-label="邮箱"
                rel="nofollow"
              >
                <i className="ri-mail-line text-base"></i>
              </a>
            </div>
            <p className="text-xs text-foreground-500 mt-4">
              联系邮箱：{siteConfig.name === "91视频" ? "contact@91video.com" : "contact@example.com"}
            </p>
          </div>
        </div>
        <div className="border-t border-background-200 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteConfig.name} 版权所有
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">
              Cookie设置
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}